import React from 'react';
import GoogleLogin from 'react-google-login';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { GuruLogo, ErrorSignal } from 'img';
import { loginAction, loginErrorAction } from 'actions/login/loginActions';
import './Login.less';

/**
 * Component/View that renders the Login Section
 * @param {Object} props
 */
const Login = (props) => {
  const { loginError } = props;

  /**
   *
   * handleLogin to set the token to the session and set logged variable
   * @param data
   */
  const handleLogin = (data) => {
    props.loginAction(data);
  };

  return (
    <div className="login_section">
      <div className="login_form">
        <img src={GuruLogo} alt="login gurú" className="logo_guru" />
        {
          loginError ? (
            <div>
              <ErrorSignal />
              <h1 className="title_error_session">Error al iniciar sesión</h1>
              <h3 className="sub_title_error_session">Intenta de nuevo</h3>
            </div>
          ) : (
            <h1 className="title_start_session">Inicia sesión para continuar</h1>
          )
        }
        <GoogleLogin
          clientId={process.env.REACT_APP_GOOGLE_AUTH}
          buttonText="Continuar con Google"
          onSuccess={(data) => { handleLogin(data); }}
          onFailure={() => { props.loginErrorAction(); }}
          cookiePolicy="single_host_origin"
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loginError: state.auth.error,
  token: state.auth.token,
});

Login.propTypes = {
  loginAction: PropTypes.func.isRequired,
  loginErrorAction: PropTypes.func.isRequired,
  loginError: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, { loginAction, loginErrorAction })(Login);
